export const getInterpolatedEvalString = ({ code, input }) => {
  // eslint-disable-next-line no-new-func
  return new Function(...Object.keys(input), `return \`${code}\`;`)(...Object.values(input));
};
